import React from 'react';
import NoDataRow from "../../../../../components/reports/no-data-row.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import { navigateHook } from "../../../../../hooks/use-navigate.js";

const DispatchContent = ({ garrison, showDetails }) => {
    const navigate = navigateHook();
    if (!showDetails) return null;
    const data = garrison?.dispatch;

    return (
        <tr>
            <td colSpan={12} style={{ padding: 0 }}>
                <table className="w-full mb-4">
                    <thead>
                        <tr>
                            <th colSpan={7} className="headerTitle text-zinc-600">
                                Despachos do plantão
                                <span className="xRayPath">
                                    <a onClick={() => ReportUtils.openXRay(navigate, 'dispatch_x_ray', garrison)}>Acessar Raio X de despachos</a>
                                </span>
                            </th>
                        </tr>

                        <tr className="divisor-header text-zinc-600">
                            <th className={'w-[4%]'}>Talão</th>
                            <th className={'w-[12%]'}>Duração</th>
                            <th className={'w-[14%]'}>Natureza</th>
                            <th className={'w-[13%]'}>Bairro</th>
                            <th className={'w-[18%]'}>Logradouro</th>
                            <th className={'w-[10%]'}>Número</th>
                            <th className={'w-[28%]'}>Observação final</th>
                        </tr>
                    </thead>

                    <tbody>
                        {!data?.length ? (
                            <NoDataRow colSpan={7} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : data.map((element, index) => {
                            const url = `/despacho/dispatch/form/${element.id}`;

                            return (
                                <tr key={index} style={{borderBottom: '1px solid #e7eaec'}}>
                                    <td className={'w-[4%]'}><a onClick={() => navigate(url, true)} className={'inner-link'}>{element.numbercheckbook || 'Sem talão'}</a></td>
                                    <td className={'w-[12%]'}>{element.dstart} {element.dend && `até ${element.dend}`}</td>
                                    <td className={'w-[14%]'}>{element.nature ?? ""}</td>
                                    <td className={'w-[13%]'}>{element.neighborhood ?? ""}</td>
                                    <td className={'w-[18%]'}>{element.street ?? ""}</td>
                                    <td className={'w-[10%]'}>{element.factnumber !== '-' ? element.factnumber : "Não informado"}</td>
                                    <td className={'w-[28%]'}>{element.finalobservation ?? ""}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default DispatchContent;
